export default __webpack_public_path__ + "static/media/servicetype_cast_192.1339e4e8.png";